import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { ILogFilters, ILogPage, ILogSource } from '../models/log.model';

/**
 * Logs techniques des services, lus par alima-core dans le répertoire de logs partagé.
 */
@Injectable({
  providedIn: 'root'
})
export class LogService {

  private readonly baseUrl = 'core/v1/logs';

  constructor(private http: HttpClient) { }

  /** État des logs de chaque service (disponibilité, dernière écriture, jours consultables). */
  getSources(): Observable<ILogSource[]> {
    return this.http.get<ILogSource[]>(`${this.baseUrl}/sources`).pipe(take(1));
  }

  /** Entrées les plus récentes correspondant aux filtres, de la plus récente à la plus ancienne. */
  getLogs(filters: ILogFilters): Observable<ILogPage> {
    let params = new HttpParams().set('service', filters.service);
    if (filters.date) params = params.set('date', filters.date);
    filters.levels?.forEach(level => params = params.append('levels', level));
    if (filters.q) params = params.set('q', filters.q);
    if (filters.user) params = params.set('user', filters.user);
    if (filters.limit) params = params.set('limit', filters.limit);
    return this.http.get<ILogPage>(this.baseUrl, { params }).pipe(take(1));
  }

  /** Fichier brut d'un service pour un jour donné. */
  download(service: string, date?: string): Observable<Blob> {
    let params = new HttpParams().set('service', service);
    if (date) params = params.set('date', date);
    return this.http.get(`${this.baseUrl}/download`, { params, responseType: 'blob' }).pipe(take(1));
  }
}
